export const DATA_ADMIN = [
    // Section 1: OPERATIONS
    { key: 1, name: "Dashboard", icon: "bx-home-circle", link: "/dashboard", title: 'Operations' },
    { key: 2, name: "Products", icon: "bx-package", link: null, children: [
      { key: 21, name: "Manage Products", link: "/products" },
      { key: 22, name: "Deleted Products", link: "/products/deleted" },
    ]}, 
    { key: 4, name: "Categories", icon: "bxl-dropbox", link: "/categories"}, 
    { key: 5, name: "Packages", icon: "bx-box", link: null, children: [
      { key: 51, name: "Manage Packages", link: "/packages" },
      { key: 52, name: "Packages Groups", link: "/packages-groups" },
    ]}, 
    { key: 6, name: "Bookings", icon: "bx-calendar", link: null, children: [
      { key: 61, name: "Manage Bookings", link: "/bookings" },
      { key: 62, name: "Calendar", link: "/calendar" },
      { key: 63, name: "Deleted Bookings", link: "/deleted-bookings" },
      { key: 64, name: "Discount Codes", link: "/discounts" },
    ]},
    { key: 3, name: "Customer Support", icon: "bx-support", link: null, children: [
      { key: 31, name: "Customer Inquiries", link: "/customers/inquiries" },
      { key: 32, name: "Customer Callbacks", link: "/customers/callback" },
    ]},
    { key: 7, name: "Customers", icon: "bx-user", link: null, children: [
      { key: 71, name: "Customer List", link: "/customers" },
      { key: 72, name: "Blacklisted Customers", link: "/customers/blacklist" },
      { key: 73, name: "Newsletter Subscriptions", link: "/customers/newsletters" },
    ]},
    { key: 8, name: "Payments", icon: "bx-credit-card", link: '/payments'},
    
    // Section 2: SYSTEM & SETTINGS
    { key: 9, name: "Users", icon: "bx-user-check", link: "/users", title:'System & Settings', },
    { key: 10, name: "Settings", icon: "bx-cog", link: null, children: [
      { key: 101, name: "General", link: "/general" },
      { key: 102, name: "Holidays", link: "/holidays" },
      { key: 103, name: "Booking Questions", link: "/booking-questions" },
      { key: 104, name: "Delivery/Postcode Pricing", link: "/delivery-pricing" },
    ]},
    { key: 11, name: "Documents", icon: "bx-file-blank",  link: null, children: [
      { key: 111, name: "Rental Document", link: "/rental-document" },
      { key: 112, name: "Privacy Document", link: "/privacy-document" },
    ]},
    { key: 12, name: "Pages", icon: "bx-file", link: null, children: [
      { key: 130, name: "Homepage", link: "/pages/home" },
      { key: 121, name: "Locations", link: "/location" },
      { key: 122, name: "Location Pages", link: "/pages/locations" },
      { key: 123, name: "Blogs", link: "/pages/blogs" },
      { key: 124, name: "Venues", link: "/pages/venue" },
      { key: 125, name: "News", link: "/pages/news" },
      { key: 126, name: "Services", link: "/pages/service" },
      { key: 127, name: "Testimonials", link: "/pages/testimonials" },
      { key: 128, name: "About Us", link: "/pages/about" },
      { key: 129, name: "Contact Us", link: "/pages/contact" },
    ]},
    // { key: 14, name: "Automation", icon: "bx-bot", link: null, children: [
    //   { key: 141, name: "SMS Templates", link: "/automation/sms-template" },
    //   { key: 142, name: "Email Templates", link: "/automation/email-template" },
    // ]},
  ];
  
export const DATA_MANAGER = [
    // Section 1: OPERATIONS
    { key: 1, name: "Dashboard", icon: "bx-home-circle", link: "/dashboard", title: 'Operations' },
    { key: 2, name: "Products", icon: "bx-package", link: null, children: [
      { key: 21, name: "Manage Products", link: "/products" },
      { key: 22, name: "Deleted Products", link: "/products/deleted" },
    ]}, 
    { key: 3, name: "Bookings", icon: "bx-calendar", link: null, children: [
      { key: 31, name: "Manage Bookings", link: "/bookings" },
      { key: 32, name: "Calendar", link: "/calendar" },
      { key: 33, name: "Deleted Bookings", link: "/deleted-bookings" },
      // { key: 54, name: "Discount Codes", link: "/discounts" },
    ]},
  ];
